import type { StoresListParams } from '../types';

/**
 * Query-key factory for admin darkstores. Use for list/detail invalidations.
 */
export const storeKeys = {
  all: ['stores', 'darkstores'] as const,
  stats: () => [...storeKeys.all, 'stats'] as const,
  lists: () => [...storeKeys.all, 'list'] as const,
  list: (params?: StoresListParams | undefined) => [...storeKeys.lists(), params ?? {}] as const,
  details: () => [...storeKeys.all, 'detail'] as const,
  detail: (id: string | undefined) => [...storeKeys.details(), id ?? 'unknown'] as const,
};
